import React from 'react';
import BaseHeader from './BaseHeader';
import { NativeStackHeaderProps } from '@react-navigation/native-stack';

export type BackDisabledStandardHeaderOwnProps = {};

export type BackDisabledStandardHeaderProps = BackDisabledStandardHeaderOwnProps & NativeStackHeaderProps;

const BackDisabledStandardHeader: React.FC<BackDisabledStandardHeaderProps> = (props) => {
    return <BaseHeader height={60} {...props} hideBackButton />;
};

export default React.memo(BackDisabledStandardHeader);
